import React from "react";
import { ApexOptions } from "apexcharts";
import {Col, Tab, Tabs} from "react-bootstrap";
import Chart from "react-apexcharts";
import { ConnectData } from "../../../types/admin";
import {ADMIN_LANG} from "../../../settings";

const ConnectChart = ({ optionsData }: { optionsData: ConnectData }) => {
    const { options1, options2, connections } = optionsData;

    const summaryData = options1.map((primaryOption) => {
        const connectionsFromPrimary = connections.filter((conn) => conn.option1_id === primaryOption.option_id);
        const correctConnection = primaryOption.correct_connection_id;
        const correctCount = connectionsFromPrimary
            .filter((conn) => conn.option2_id === correctConnection)
            .reduce((sum, conn) => sum + conn.amount, 0);
        const wrongCount = connectionsFromPrimary.reduce((sum, conn) => sum + conn.amount, 0) - correctCount;

        return {
            label: primaryOption.label,
            correct: correctCount,
            wrong: wrongCount,
        };
    });

    const summarySeries = [
        {
            name: ADMIN_LANG.correct_connections,
            data: summaryData.map((data) => data.correct),
        },
        {
            name: ADMIN_LANG.incorrect_connections,
            data: summaryData.map((data) => data.wrong),
        },
    ];

    const summaryOptions: ApexOptions = {
        chart: {
            type: "bar",
            height: 350,
            stacked: true,
            toolbar: {
                show: false,
            },
        },
        plotOptions: {
            bar: {
                horizontal: true,
            },
        },
        dataLabels: {
            enabled: false,
        },
        xaxis: {
            categories: summaryData.map((data) => data.label),
        },
        colors: ["#28a745", "#dc3545"], // Green for correct, red for wrong
    };

    return (
        <Col xs={12} lg={6} className="mb-4 mb-lg-0">
        <div className="admin-card">
            <Tabs defaultActiveKey="summary" id="connection-tabs" className="chartTabs">
                <Tab eventKey="summary" title={ADMIN_LANG.summary}>
                    <h3>{ADMIN_LANG.summary}</h3>
                    <Chart options={summaryOptions} series={summarySeries} type="bar" height={350} />
                </Tab>
                {options1.map((primaryOption, primaryIndex) => {
                    const connectionsFromPrimary = connections.filter(
                        (conn) => conn.option1_id === primaryOption.option_id
                    );

                    const allPossibleConnections = options2.map((secondaryOption) => {
                        const existingConnection = connectionsFromPrimary.find(
                            (conn) => conn.option2_id === secondaryOption.option_id
                        );
                        return {
                            label: secondaryOption.label,
                            value: existingConnection ? existingConnection.amount : 0,
                            color: existingConnection
                                ? secondaryOption.option_id === primaryOption.correct_connection_id
                                    ? "#28a745"
                                    : "#dc3545"
                                : "#dc3545",
                        };
                    });

                    const labels = allPossibleConnections.map((conn) => conn.label);
                    const values = allPossibleConnections.map((conn) => conn.value);
                    const colors = allPossibleConnections.map((conn) => conn.color);

                    const series = [
                        {
                            name: `${ADMIN_LANG.connected_to}: ${primaryIndex + 1}. ${primaryOption.label}`,
                            data: values,
                        },
                    ];

                    const options: ApexOptions = {
                        chart: {
                            type: "bar",
                            height: 350,
                            toolbar: {
                                show: false,
                            },
                        },
                        plotOptions: {
                            bar: {
                                horizontal: true,
                                colors: {
                                    ranges: values.map((value, index) => ({
                                        from: value,
                                        to: value,
                                        color: colors[index],
                                    })),
                                },
                            },
                        },
                        dataLabels: {
                            enabled: false,
                        },
                        xaxis: {
                            categories: labels,
                        },
                        tooltip: {
                            y: {
                                formatter: (val: number) => `${val}`,
                            },
                        },
                    };

                    return (
                        <Tab eventKey={primaryOption.option_id} title={`${primaryIndex + 1}. ${primaryOption.label}`} key={primaryOption.option_id}>
                            <h3>{primaryIndex + 1}. {primaryOption.label}: <span className='text-lowercase'>{ADMIN_LANG.connections}</span></h3>
                            <Chart options={options} series={series} type="bar" height={350} />
                        </Tab>
                    );
                })}
            </Tabs>
        </div>
        </Col>
    );
};

export default ConnectChart;